// extracted by mini-css-extract-plugin
module.exports = {"button":"_92ec46d"};